// Validation error captions for TaskDateTimeFields.
import { Typography } from '@mui/material';

export function TaskDateTimeFieldErrors({ errors }) {
  return (
    <>
      {errors.date ? (
        <Typography
          color="error"
          variant="caption"
          sx={{ display: 'block', mt: 0.5 }}
        >
          {errors.date}
        </Typography>
      ) : null}
      {errors.time ? (
        <Typography
          color="error"
          variant="caption"
          sx={{ display: 'block', mt: 0.5 }}
        >
          {errors.time}
        </Typography>
      ) : null}
      {errors.duration ? (
        <Typography
          color="error"
          variant="caption"
          sx={{ display: 'block', mt: 0.5 }}
        >
          {errors.duration}
        </Typography>
      ) : null}
    </>
  );
}
